import { render, staticRenderFns } from "./AddEditNonAutomateGroupName.vue?vue&type=template&id=44545c80&scoped=true"
import script from "./AddEditNonAutomateGroupName.vue?vue&type=script&lang=js"
export * from "./AddEditNonAutomateGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44545c80",
  null
  
)

export default component.exports